import { Text, Heading, Button, useWizardContext } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { FittingRoomValues } from '../types'
import { useFittingRoomContext } from '../FittingRoomProvider'

export const YourLoungeFit = () => {
  const { t } = useTranslation()
  const { returnTo } = useFittingRoomContext()
  const { values } = useWizardContext<FittingRoomValues>()

  const { loungeFit } = values

  const items = [
    {
      heading: t('general.bra'),
      content:
        loungeFit?.bandSize && loungeFit?.cupSize
          ? `${loungeFit?.bandSize}${loungeFit?.cupSize}`
          : undefined,
    },
    {
      heading: t('general.bralette'),
      content: loungeFit?.braletteSize,
    },
    {
      heading: t('general.bottoms'),
      content: loungeFit?.bottomsSize,
    },
  ]

  return (
    <div className="px-6 pb-[116px] sm:pb-0 flex flex-col items-center justify-center gap-y-4">
      <div className="flex flex-col gap-y-3 items-center">
        <Heading variant="title-two">
          <Text as="span" variant="title-five" className="normal-case">
            {t('general.your')}
          </Text>
          {t('fitting_room.lounge_fit')}
        </Heading>
      </div>
      <div className="flex flex-col gap-y-10">
        <div className="flex flex-col gap-y-6">
          {items.map(({ heading, content }) => (
            <div key={heading} className="flex flex-col gap-y-2 items-center">
              <Text>{heading}</Text>
              <Text variant="title-four">
                {content ?? t('general.unavailable')}
              </Text>
            </div>
          ))}
        </div>
        <Button as="a" href={returnTo} size="lg">
          {t('action.continue_shopping')}
        </Button>
      </div>
    </div>
  )
}
